import { getData } from "../../utils/serverHelper";
import { APPOINTMENT } from "../../utils/urls";
import { loadingAppointmentReports, loadingPaitientsReports, loadingReports, loadingRevenueReports } from "./reducer";


export const getAppointmentReport = async(dispatch,startdate,enddate,staffid)=>{
    try{
        dispatch(loadingReports())
        const data = await getData(APPOINTMENT+`/appointments?date=${startdate}&end_date=${enddate}&staff=${staffid}`);
        console.log("report 1",data);
        // dispatch(loadingReports(data.data))
     if(staffid!=0){
        const filteredAppointments = data.data.filter((appointment) => {
            return appointment.staff_id === staffid;
          });
        dispatch(loadingAppointmentReports(filteredAppointments));
     }else{
        dispatch(loadingAppointmentReports(data.data));
     }
       
    }catch(err){
        console.log(err);
    }
}


export const getRevenueReport = async(dispatch,startdate,enddate,staffid)=>{
    try{
        dispatch(loadingReports())
        const data = await getData(APPOINTMENT+`/price?date=${startdate}&end_date=${enddate}&staff=${staffid}`);
        console.log("report 2",data);
        if(staffid!=0){
            const filteredRevenue = data.data.filter((appointment) => {
                return appointment.staff_id === staffid;
              });
            dispatch(loadingRevenueReports(filteredRevenue))
        }else{
            dispatch(loadingRevenueReports(data.data))

        }
      
    }catch(err){
        console.log(err);
    }
}


export const getPaitientsReport = async(dispatch,startdate,enddate,staffid)=>{
    try{
        dispatch(loadingReports())
        const data = await getData(APPOINTMENT+`/patients?date=${startdate}&end_date=${enddate}&staff=${staffid}`);
       
        if(staffid!=0){
            const filteredPaitientsx = data.data.filter((appointment) => {
                return appointment.staff_id === staffid;
              });
        dispatch(loadingPaitientsReports(filteredPaitientsx))
            
        }else{
        dispatch(loadingPaitientsReports(data.data))

        }
        console.log("report 3",data);
    }catch(err){
        console.log(err);
    }
}